import { useEffect } from 'react';
import { useLang } from '../contexts/LangContext';
import { APP_NAME } from '../utils/appConfig';

export function useDocumentTitle() {
  const { t, lang } = useLang();

  useEffect(() => {
    document.title = `${APP_NAME}: ${t('documentTitleTagline')}`;
  }, [t, lang]);
}
